import { FC } from "react";

import { useEventContext } from "Bands/contexts";
import { IEventBlock } from "Bands/types";
import { Loader } from "shared/components";
import { EventBlocks } from "../components/EventBlocks";
import { ScheduleFilterType } from "Bands/containers";

interface EventBlockProps {
  filterIds?: string[];
  showPersonalInfo?: boolean;
  showActions?: boolean;
  isPrint?: boolean;
  filterType?: ScheduleFilterType;
  isPushCopyModalOpen?: boolean;
  setIsPushCopyModalOpen?: (isPushCopyModalOpen: boolean) => void;
}

export const EventBlocksContainer: FC<EventBlockProps> = ({
  filterIds,
  isPushCopyModalOpen,
  setIsPushCopyModalOpen,
  ...props
}) => {
  const { eventBlocks, fetchingEventBlocks } = useEventContext();

  if (fetchingEventBlocks) return <Loader />;

  if (!filterIds) return <EventBlocks blocks={eventBlocks || []} {...props} />;

  const filteredBlocks: IEventBlock[] = [];

  filterIds?.forEach(id => {
    const found = eventBlocks?.find(block => block.id === id);

    found && filteredBlocks.push(found);
  });

  return <EventBlocks blocks={filteredBlocks} {...props} />;
};
